import Utility from "app/horoscope/utility/utility";
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function AspectRashiTable({ aspectData }) {
    const { t } = useTranslation();
    return (
        <div>
            <div style={sectionTitleStyle}>
                {t("AspectRashi")}
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>-</th>
                        <th style={thStyleCompact}>{t("PLANET")}</th>
                        <th style={thStyleCompact}>{t("ThenpathRashiya")}</th>
                        <th style={thStyleCompact}>{t("AspectedRashi")}</th>
                        <th style={thStyleCompact}>{t("AspectedBhava")}</th>
                        <th style={thStyleCompact}>{t("AspectedPlanet")}</th>
                    </tr>
                </thead>
                <tbody>
                    {aspectData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                            <td style={tdStyleCompact}>{row.planet}</td>
                            <td style={tdStyleCompact}>{row.rasi}</td>
                            <td style={tdStyleCompact}>{row.aspectedRasis}</td>
                            <td style={tdStyleCompact}>{row.aspectedHouses}</td>
                            <td style={tdStyleCompact}>{row.aspectedPlanets}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    AspectRashiTable.propTypes = {
        aspectData: PropTypes.arrayOf(PropTypes.object).isRequired,
    };
}